<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import normalPrint from "./normal/index.vue";
import artificialPrint from "./artificial/index.vue";

@Component({
  name: "excipient-print",
  components: {
    normalPrint,
    artificialPrint
  }
})
export default class App extends Vue {
  pageType = null;
  //  已复核
  // Accessory_Developer_Review_Page_1() {
  //   this.$apis.excipient
  //     .Accessory_Developer_Review_Page({
  //       ...this.$utils.formatParams(this.paramsList),
  //       ...this.info.reviewedEnd.pagination,
  //       confirmFlag: 1
  //     })
  //     .done(res => {
  //       this.info.reviewedEnd.list = res.list;
  //       this.info.reviewedEnd.pagination.total = res.totalCount;
  //     })
  //     .fail(err => {});
  // }
  mounted() {
    const { type } = this.$route.query;
    this.pageType = type;
  }
  render(h) {
    return (
      <div class="excipient-print">
        {this.pageType == 1 && <artificial-print></artificial-print>}
        {this.pageType == 0 && <normal-print></normal-print>}
      </div>
    );
  }
}
</script>
<style>
  .excipient-print {
    margin: 0 auto;
    padding: 0 16px;
  }
</style>
